import { Tooltip } from "antd";
import axios from "axios";
import fileDownload from "js-file-download";
import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import Heading from "../../../Components/Heading/Heading";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  EngagementExportToExcel,
  GetDropDownList,
  getEngagementMasterGridData,
} from "../../../Helpers/API/APIEndPoints";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import {
  ActiveStatusOptions,
  enagagementTypeOptions,
  engagementStatusOptions,
  poStatusOptions,
} from "../../../Common/CommonJson";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import {
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
  FormControl,
} from "@mui/material";

const EngagementMaster = () => {
  let navigate = useNavigate();
  const [engagementMasterData, setEngagementMasterData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  //sangam 2-mar-2024
  const [customerOptions, setCustomerOptions] = useState<any>([]);
  const [customerSelectedData, setCustomer] = useState(
    JSON.parse(localStorage.getItem("customerSelectedData") || "[]"));   //deepak gupta
  const [engagementSelectedData, setEngagement] = useState([]);
  const [engagementSelectedTypeData, setEngagementTypes] = useState(
    JSON.parse(localStorage.getItem("engagementSelectedTypeData") || "[]"));   //deepak gupta
  const [engagementStatusData, setEngagementStatus] = useState(
    JSON.parse(localStorage.getItem("engagementStatusData") || "[]"));   //deepak gupta
  const [poStatusData, setPoStatus] = useState(
    JSON.parse(localStorage.getItem("poStatusData") || "[]"));   //deepak gupta
  //const [activeStatusData,setActiveStatus] = useState()
  const { showLoader, hideLoader } = useContext(LoaderContext);
  // const[isactive,setIsActive]= useState("All");// isActive Filter -- sangam
  const [activeStatusData, setIsActive] = useState("active"); // isActive Filter -- sangam
  const [reset, setReset] = React.useState<any>(false);

     //deepak gupta
  useEffect(() => {
    localStorage.setItem("customerSelectedData",JSON.stringify(customerSelectedData));
    localStorage.setItem("engagementSelectedTypeData",JSON.stringify(engagementSelectedTypeData));
    localStorage.setItem("engagementStatusData",JSON.stringify(engagementStatusData));
    localStorage.setItem("poStatusData",JSON.stringify(poStatusData));
  }, [customerSelectedData, engagementSelectedTypeData, engagementStatusData, poStatusData]);

  //sangam 2-mar-2024
  useEffect(() => {

       //deepak gupta
    const clearUnwantedLocalStorage = () => {
      const keysToKeep = ["customerSelectedData", "engagementSelectedTypeData", "engagementStatusData", "poStatusData"];
      Object.keys(localStorage).forEach((key) => {
        if (!keysToKeep.includes(key)) {
          localStorage.removeItem(key);
        }
      });
    };

    onLoadApi();
    clearUnwantedLocalStorage();   //deepak gupta
  }, []);

  const onLoadApi = async () => {
    await customerApiCall();
  };

  const customerApiCall = async () => {
    let postObject = {
      searchFor: "customer",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let customerArray = [];
      await data.map((customer: any) => {
        let tempObj = {
          abb: customer.abbreviation,
          value: customer.id,
          label: customer.name,
        };
        customerArray.push(tempObj);
      });
      setCustomerOptions(customerArray);
    }
  };

  const getEngagementMasterData = async () => {
    //sangam 6-mar-2024
    showLoader();
    let customers = await ConvertArrayToString(customerSelectedData);
    let engagementType = await ConvertArrayToString(engagementSelectedTypeData);
    let engagementStatus = await ConvertArrayToString(engagementStatusData);
    let poStatus = await ConvertArrayToString(poStatusData);
    //let activeStatus =await ConvertArrayToString(activeStatusData);
    let requestParams = {
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn === "" ? "CreatedDate" : sortColumn,
      sortDirection: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText,

      //sangam 6-mar-2024
      customerFilterOptions: customers,
      engagementTypeFilterOptions: engagementType,
      engagementStatusFilterOptions: engagementStatus,
      poStatusFilterOptions: poStatus,
      activeStatusFilterOptions: activeStatusData,
      //
    };

    const { data } = await APICall(
      getEngagementMasterGridData,
      "POST",
      requestParams
    );
    setEngagementMasterData(data);
    // setEngagementMasterData(data?.engagementMasterData);commented by mahesh
    setCount(data[0]?.totalCount);
    hideLoader();
  };

  //sangam 6-mar-2024
  const ConvertArrayToString = async (arr) => {
    if (arr && arr.length > 0) {
      let s = [];
      arr.map((v) => s.push(v.value));
      return s.join(",");
    } else {
      return "";
    }
  };

  useEffect(() => {
    getEngagementMasterData();
  }, [
    start,
    sortColumn,
    sortDirection,
    searchText,
    count,
    reset,
    activeStatusData,
  ]);

  // createdBy: 17
  // createdDate: "2022-08-12T07:56:12.333"
  // customer: "demo1"
  // customerId: 6
  // engagement: "product ex"
  // engagementType: 2
  // id: 25
  // isActive: true
  // modifiedBy: null
  // modifiedDate: null
  // pageSize: 0
  // povalue: 123
  // searchText: ""
  // sortColumn: ""
  // sortDirection: ""
  // start: 0

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "customerId",
      label: "customerId",
      options: {
        display: false,
      },
    },
    {
      name: "customerName",
      label: "Customer",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "engagement",
      label: "Engagement",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "streamName",
      label: "Stream",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "currentStageName",
      label: "Stages",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "functionOwnerName",
      label: "Functional Owner",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },

    // {
    //   name: "engagementType",
    //   label: "Engagement Type",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     sortDescFirst: true,
    //     customBodyRender: (value, tableMeta) => {
    //       if (value) {
    //         let label = "";
    //         enagagementTypeOptions.map((ele: any) => {
    //           if (ele.value === Number(value)) {
    //             label = ele.label;
    //           }
    //         });
    //         return label;
    //       }
    //     },
    //   },
    // },
    // {
    //   name: "engagementStatus",
    //   label: "Engagement Status",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       if (value === 1) {
    //         return "Not Started";
    //       } else if (value === 2) {
    //         return "In-Progess ";
    //       } else if (value === 3) {
    //         return "Completed";
    //       }
    //     },
    //   },
    // },

    {
      name: "povalue",
      label: "PO Value",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({
          style: { display: "flex", justifyContent: "right" },
        }),
      },
    },

    {
      name: "postatus",
      label: "PO Status",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value === 1) {
            return "Recieved";
          } else if (value === 2) {
            return "Expired";
          } else if (value === 3) {
            return "Pending";
          } else if (value === 4) {
            return "Not Applicable";
          }
        },
      },
    },
    {
      name: "isActive",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("edit", { state: id });
                  }}
                  className="action_icon"
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  //function that handle the input value for isActive filter -- sangam
  const handleChange = async (event: SelectChangeEvent) => {
    await setIsActive(event.target.value);
  };

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,

    setCellHeaderProps: () => ({ align: "center" }),

    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },

    //sangam
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={activeStatusData}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };

  const ExportToExcel = async () => {
    //sangam
    let customerIds = await ConvertArrayToString(customerSelectedData);
    let engagementTypeIds = await ConvertArrayToString(
      engagementSelectedTypeData
    );
    let engagementStatusIds = await ConvertArrayToString(engagementStatusData);
    let poStatusIds = await ConvertArrayToString(poStatusData);
    //let activeStatusIds = await ConvertArrayToString(activeStatusData);
    axios
      .request({
        responseType: "blob",
        method: "POST",

        //data: Response,
        url: EngagementExportToExcel,
        //data:JSON,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: {
          searchText: searchText,
          sortColumn: sortColumn,
          sortDirection: sortDirection,
          master: "engagement",
          //sangam
          customerId: customerIds,
          engagementTypeId: engagementTypeIds,
          engagementStatusId: engagementStatusIds,
          poStatusId: poStatusIds,
          activeStatusId: activeStatusData,
        },
      })
      .then((response) => {
        fileDownload(response.data, "Engagement Report.xlsx");
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };

  //sangam
  const ResetFunction = () => {
    setCustomer([]);
    setEngagementTypes([]);
    setEngagementStatus([]);
    setPoStatus([]);
    setIsActive("All");
    localStorage.removeItem("customerSelectedData");   //deepak gupta
    localStorage.removeItem("engagementSelectedTypeData");   //deepak gupta
    localStorage.removeItem("engagementStatusData");   //deepak gupta
    localStorage.removeItem("poStatusData");   //deepak gupta
  };

  const onClickFunction = async (action) => {
    if (action === "Submit") {
      await getEngagementMasterData();
    } else {
      await ResetFunction();
      setReset(!reset);
    }
  };

  //sangam
  const SelectOnChange = (event, apiField) => {
    if (apiField == "customer") {
      setCustomer(event);
    }
    if (apiField == "engagement") {
      setEngagement(event);
    }
    if (apiField == "engagementType") {
      setEngagementTypes(event);
    }
    if (apiField == "engagementStatus") {
      setEngagementStatus(event);
    }
    if (apiField == "poStatus") {
      setPoStatus(event);
    }
    // if(apiField == "activeStatus"){
    //     setActiveStatus(event)
    // }
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"Engagement Master"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button
                  onClick={() => navigate("edit")}
                  className="btn btn-update"
                >
                  Create
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={() => ExportToExcel()}
                  className="btn btn-export"
                >
                  Export to Excel
                </button>
                <a className="filterIcon" onClick={toggleFilter}>
                  <i className="fa fa-filter"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Customer</label>
                    <SelectForm
                      value={customerSelectedData}
                      onChange={(e) => SelectOnChange(e, "customer")}
                      options={customerOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select EngagementType</label>
                    <SelectForm
                      value={engagementSelectedTypeData}
                      onChange={(e) => SelectOnChange(e, "engagementType")}
                      options={enagagementTypeOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Engagement Status</label>
                    <SelectForm
                      value={engagementStatusData}
                      onChange={(e) => SelectOnChange(e, "engagementStatus")}
                      options={engagementStatusOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select PO Status</label>
                    <SelectForm
                      value={poStatusData}
                      onChange={(e) => SelectOnChange(e, "poStatus")}
                      options={poStatusOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end">
                    <button
                      onClick={() => onClickFunction("reset")}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => onClickFunction("Submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={engagementMasterData}
              columns={gridColumns}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default EngagementMaster;
